import React, { memo, useEffect } from "react";
import { AlertDialog } from "../common/AlertDailog";
import { useSnackbar } from "../../hooks/useSnackbar";
import { useAppDispatch, useAppSelector, AppState } from "../../store";
import { useVendors } from "../../hooks/useVendors";
import { setOpenDeleteVendor } from "../../store/slices/vendorSlice";
import { useParams } from "react-router-dom";

const DeleteVendorDialog: React.FunctionComponent<any> = (props) => {
  const { showSuccess, handleError } = useSnackbar();
  const {
    paginationModel,
    filterVal,
    getAllVendorsFunc,
    setOpenVendorDetails,
  } = props;
  const {
    deleteVendor,
    deleteVendorData,
    deleteVendorIsError,
    deleteVendorError,
    deleteVendorIsSuccess,
  } = useVendors();
  const dispatch = useAppDispatch();
  const params = useParams();
  const VendorData = useAppSelector(
    (state: AppState) => state.vendorSlice.vendorDetails
  );
  const openDelete = useAppSelector(
    (state: AppState) => state.vendorSlice.openDeleteVendor
  );
  const handleCloseDeleteVendor = () => {
    dispatch(setOpenDeleteVendor(false));
  };
  const handleDeleteVendor = () => {
    deleteVendor({
      study_id: params?.study_id,
      vendor_id: VendorData?.vendor_id,
    });
  };
  useEffect(() => {
    if (deleteVendorIsSuccess) {
      const successMsg = deleteVendorData;
      getAllVendorsFunc(0, paginationModel?.pageSize, filterVal);
      showSuccess(successMsg?.details, "vendor-delete-success");
      handleCloseDeleteVendor();
      setOpenVendorDetails && setOpenVendorDetails(false);
    }
  }, [deleteVendorIsSuccess]);
  useEffect(() => {
    if (deleteVendorIsError) {
      const errorMsg: any = deleteVendorError;
      handleError(errorMsg);
    }
  }, [deleteVendorIsError]);
  return (
    <>
      <AlertDialog
        open={openDelete}
        title="Delete Vendor"
        description={`Are you sure you want to delete the vendor <strong>${VendorData?.vendor_id}</strong>?`}
        handleClose={handleCloseDeleteVendor}
        handleConfirm={handleDeleteVendor}
        confirmBtn="Yes"
        cancelBtn="No"
        maxWidth="xs"
      />
    </>
  );
};

export default memo(DeleteVendorDialog);
